export const ARCHIVE_SET_MEET = 'ARCHIVE_SET_MEET';
export const ARCHIVE_DELETE_FILE = 'ARCHIVE_DELETE_FILE';
export const ARCHIVE_DOWNLOAD_FILE = 'ARCHIVE_DOWNLOAD_FILE';
